import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("bk_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const getToken = () => localStorage.getItem("bk_token");
export const setToken = (t) => localStorage.setItem("bk_token", t);
export const clearToken = () => localStorage.removeItem("bk_token");

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : "")).filter(Boolean).join(" ");
  return e?.message || "Something went wrong. Please try again.";
}

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (iso) =>
  new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export default api;
